import { AlertSoundType, AlertStatus, DriverDto } from '@fleet-beat/api';
import { BaseEntityDto, UserDto } from '@fleet-beat/core';

export interface AlertDto extends BaseEntityDto {
  id?: string;
  companyId?: string;
  userId?: string;
  driverId: string;
  driver?: DriverDto;
  soundType: AlertSoundType;
  message: string;
  status?: AlertStatus;
  sentStatus?: string;
  sentDetails?: string;
  user?: UserDto;
  userName?: string;
  driverName?: string;
  isHighVolume?: boolean;
}
